var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftBlue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 365,
    viewBox: "0 0 215 365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37158 0.896729C68.7111 22.2499 140.036 40.4564 213.506 54.9541V334.794C140.036 342.661 68.7111 352.55 1.37158 364.238V0.896729Z",
    fill: "#00C8D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.88244 1.5711C68.9154 22.8119 139.933 40.906 212.995 55.2913V334.119C139.933 341.986 68.9154 351.764 1.88244 363.339V1.5711ZM0.860596 0.110107V364.8C68.0979 353.112 139.423 343.222 214.017 335.243V54.3922C139.423 39.7821 68.0979 21.5757 0.860596 0.110107Z",
    fill: "#00C8D5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBlue1);
export default __webpack_public_path__ + "static/media/LeftBlue1.0308f2b84b15244fa2091b35148aa2dc.svg";
export { ForwardRef as ReactComponent };